<template>
  <div v-if="shouldShowJson">
    <p
      v-if="title"
      class="text-xs text-muted text-left"
    >{{ title }}</p>
    <div>
      <VueJsonPretty
        :deep="deep"
        :data="data"
        :editable="editable"
        @change="handleChange"
      />
    </div>
  </div>
</template>

<script setup>
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';

const adminSettings = useAdminSettings()
const route = useRoute()

const emit = defineEmits(['change'])

const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  data: {
    type: [Object, Array],
    required: false
  },
  forceShow: {
    type: Boolean,
    default: false
  },
  editable: {
    type: Boolean,
    default: false
  },
  deep: {
    type: Number,
    default: 1
  }
});

const isJsonInUrl = computed(() => route.query.json === 'true')
const isJsonToggled = ref(false)

const shouldShowJson = computed(() =>
  isJsonInUrl.value ||
  isJsonToggled.value ||
  props.forceShow ||
  (validatePermission('view', 'admin_area') && adminSettings.showJSON)
)

const handleKeyDown = (event) => {
  if ((event.ctrlKey || event.metaKey) && event.key === 'j') {
    event.preventDefault()
    isJsonToggled.value = !isJsonToggled.value
  }
}

const handleChange = (newData) => {
  emit('change', newData)
}

onMounted(() => {
  window.addEventListener('keydown', handleKeyDown)
})

onUnmounted(() => {
  window.removeEventListener('keydown', handleKeyDown)
})
</script>